import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import InsuranceModel from '@/shared/models/configuration/insurancemodel'
import InsuranceForms from './insurance-form'

export default {
  name: 'Insurance',
  mixins: [ActionsForm],
  data () {
    return {
      data: InsuranceModel,
      form: InsuranceForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      InsuranceRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      InsuranceRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      InsuranceRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      InsuranceRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/insurance/insurance.js